<template>
  <v-app id="inspire">
   <div class="d-flex text-center flex-column flex-md-row flex-grow-1">
    <v-sheet class="layout-side mx-auto mx-md-1 d-none d-md-flex flex-md-column justify-space-between px-2">
      <div class="mt-3 mt-md-10 pa-2">
        <div class="display-2 font-weight-bold primary--text">
          Aspire
        </div>
        <div class="title my-2" style="font-weight:700 !important">Building Industry Platform.</div>
        
      </div>
      <img class="w-full" src="../images/illustrations/signin-illustration.svg" />
    </v-sheet>

    <div class="pa-2 pa-md-4 flex-grow-1 align-center justify-center d-flex flex-column">
      <div class="layout-content ma-auto w-full">
        <router-view></router-view>
      </div>
       <div class="overline mt-4">aspire systems</div>
    </div>
  </div>
  
  </v-app>
</template>

<script>
import { PATH_LOGIN, PATH_REGISTER } from "@/data/pathData";
export default {
  data: () => ({
    path: {
      login: PATH_LOGIN,
      register: PATH_REGISTER,
    },
  }),
};
</script>

<style>
.layout-side {
  width: 420px;
}

.layout-content {
  max-width: 480px;
}
</style>
